<template>
  <v-app>
    <v-main>
      <nav-header />
      <v-container>
        <router-view v-if="showView" :key="$route.path" />
        <loader></loader>
      </v-container>
    </v-main>
    <nav-footer />
  </v-app>
</template>

<script>
import NavHeader from '@/components/navigation/NavHeader.vue'
import NavFooter from '@/components/navigation/NavFooter.vue'
import Loader from '@/components/Loader.vue'

export default {
  name: 'App',
  components: {
    NavHeader,
    NavFooter,
    Loader,
  },
  data: function () {
    return {
      authenticated: false,
    }
  },
  computed: {
    showView() {
      // if no auth is required to view the show view
      if (this.$route.meta.requiresAuth === false) {
        return true
      }
      // otherwise check if user is authenticated
      return !this.authenticated || (this.authenticated && this.$route.meta.requiresAuth)
    },
  },
  watch: {
    $route: 'checkAuthState',
  },
  mounted() {
    this.checkAuthState()
  },
  methods: {
    async checkAuthState() {
      let previouslyLoggedIn = this.authenticated
      this.authenticated = await this.$auth.isAuthenticated()
      let justLoggedIn = !previouslyLoggedIn && this.authenticated
      if (justLoggedIn) {
        //update store with token
        this.$store.dispatch('updateAccessToken', this.$auth.authStateManager._authState.accessToken.value)
        //console.log('store token updated')
        this.$api.user.getUserInfo(this.$store.state.accessToken).then(user => {
          //get users role, access, terms accepted info and store it in the state
          this.$store.dispatch('auth/updateUser', user.data)
          //console.log('store user data updated')
          if (!user.data.termsAccepted && this.$route.name != 'TermsConditions') {
            if (this.$router.currentRoute.name != 'AcceptTermsConditions') {
              this.$router.push({ name: 'AcceptTermsConditions' })
            }
          } else {
            if (
              this.$store.state.accessToken != null &&
              this.$route.name != 'NoAccess' &&
              !this.$route.meta.accessRestricted
            ) {
              if (this.$router.currentRoute.name != this.$route.name) {
                this.$router.push({ name: this.$route.name })
              }
            } else if (this.$store.getters['auth/checkAccess']('Dashboard')) {
              if (this.$router.currentRoute.name != 'Dashboard') {
                this.$router.push({ name: 'Dashboard' })
              }
            } else if (this.$store.getters['auth/checkAccess']('SummaryAndNominations')) {
              if (this.$router.currentRoute.name != 'SummaryAndNominations') {
                this.$router.push({ name: 'SummaryAndNominations' })
              }
            } else {
              if (
                this.$router.currentRoute.name == 'Dashboard' &&
                !this.$store.getters['auth/checkAccess']('Dashboard') &&
                this.$store.getters['auth/checkAccess']('Access')
              ) {
                this.$router.push({ name: 'Access' })
              } else if (this.$router.currentRoute.name != 'NoAccess') {
                this.$router.push({ name: 'NoAccess' })
              }
            }
          }
        })
      }
    },
  },
}
</script>
